module.exports = __webpack_public_path__ + "static/img/5-5.2284ce2e.jpeg";